<div id="dashboardMap" #dashboardMap class="mapa" style="height: 99vh;"></div>
<div class="menu-control" [ngClass]="isOpen ? 'active': ''">
  <div class="d-toggle d-block d-sm-none" (click)="toggleView($event)">
    <div class="toggle-ctrl"></div>
  </div>
  <div class="nav-control d-none d-sm-block">
    <div class="nav-item text-center" *ngFor="let nav of navCtrlr" (click)="toggleControl(nav)" [ngClass]="nav.active ? 'active' : ''">
      <img [src]="nav.src_img" alt="{{nav.title}}">
    </div>
  </div>
  <div class="nav-control-tiny d-block d-md-none" >
    <div class="row">
      <div class="col-4 nav-item text-center" *ngFor="let nav of navCtrlr" (click)="toggleControl(nav)" [ngClass]="nav.active ? 'active' : ''">
        <img [src]="nav.src_img" alt="{{nav.title}}">
      </div>
    </div>
  </div>
  <div class="data-control">
    <div>
      <div class="row" [ngClass]="navCtrlr[0].active ? '' : 'hidden'">
        <div class="col-12">
          <h2 class="mb-4">{{navCtrlr[0].title}}</h2>
          <div class="row" *ngIf="!loading">
            <div class="col-12 mb-4" >
              <div class="row single-indicator" *ngFor="let alcaldia of groupByAlcaldia; let i = index;">
                <div class="col-10">
                  <h3 class="mb-0 indicator-name">{{alcaldia}}</h3>
                </div>
                <div class="col-2 text-right">
                  <a class="toggler" (click)="loadSegment($event, alcaldia, i)">+</a>
                </div>
                <div class="col-12">
                  <hr class="mt-1 mb-2" style="border-top: 2px solid #00AE42;"/>
                  <div id="alcaldia-{{i}}" class="row info-block hidden" [ngClass]="toogled ? 'hidden': ''">
                    <div class="col-4">
                      <p class="mb-0 mt-2" style="font-size: 11px !important;">Mujeres:</p>
                      <h2 style="font-size: 17px !important;">{{selectedGroup.count_m | number: "1.0"}}</h2>
                    </div>
                    <div class="col-4">
                      <p class="mb-0 mt-2" style="font-size: 11px !important;">Hombres:</p>
                      <h2 style="font-size: 19px !important;">{{selectedGroup.count_h | number: "1.0"}}</h2>
                    </div>
                    <div class="col-4">
                      <p class="mb-0 mt-2" style="font-size: 11px !important; line-height: 1;">Promedio</p>
                      <h2 style="font-size: 19px !important;">${{selectedGroup.avg_salario | number: "1.0-2"}}</h2>
                    </div>
                    <div class="col-12">
                      <div #chart id="chart"></div>
                    </div>
                    <div class="col-12">
                      <div class="" id="pie-container-{{i}}"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" [ngClass]="navCtrlr[1].active ? '' : 'hidden'">
        <div class="col-12">
          <h2 class="mb-4">{{navCtrlr[1].title}}</h2>
        </div>
        <div class="tooltip"></div>
        <div id="hozChart" *ngIf="!loading"></div>

      </div>
      <div class="row" [ngClass]="navCtrlr[2].active ? '' : 'hidden'">
        <div class="col-12">
          <!-- h1 class="mb-4">Información</h1 -->
          <h2 class="mb-4" style="font-weight: 600;">{{navCtrlr[2].title}}</h2>
          <p style="font-size: 15px;">Información sobre las personas servidoras públicas cuyo puesto está afiliado a las alcaldías de la Ciudad de México y que es usada para llenar el mapa de interactivo de las alcaldías en la sección de Remuneraciones al personal del Gobierno de la Ciudad de México en el portal de Tu Ciudad, Tu Dinero: tudinero.cdmx.gob.mx</p>
          <h4 class="mt-3" style="font-size: 14px !important; font-weight: 600 !important; text-transform: uppercase;">Información adicional</h4>
          <p style="font-size: 14px !important;"><b>Última actualización:</b> 15 de febrero de 2021</p>
        </div>
        <div class="col-12 mt-4">
          <h3>Metricas</h3>
          <div class="form-group" *ngFor="let metrics of data.payload">
            <label for="metric" class="label-form-control text-uppercase">{{metrics.item}}</label>
            <select class="form-control" name="metric" (change)="updateMetric($event, metrics)">
              <option *ngFor="let control of metrics.group" [ngValue]="control">{{control.metric}}</option>
            </select>
          </div>
        </div>
        <!-- div class="row" *ngIf="!loading">
          <div class="col-12">
            <h4 class="mt-3" style="font-size: 14px !important; font-weight: 600 !important; text-transform: uppercase;">Información general de la CDMX</h4>
          </div>
          <div class="col-12">
            <p class="mb-0 mt-2">Mujeres:</p>
            <h2 style="font-size: 17px !important;">{{selectedGroup.total_m | number: "1.0"}}</h2>
          </div>
          <div class="col-12">
            <p class="mb-0 mt-2">Hombres:</p>
            <h2 style="font-size: 19px !important;">{{selectedGroup.total_h | number: "1.0"}}</h2>
          </div>
          <div class="col-12">
            <p class="mb-0 mt-2">Promedio</p>
            <h2 style="font-size: 19px !important;">${{selectedGroup.total | number: "1.0-2"}}</h2>
          </div>
        </div -->
    </div>
    <div  *ngIf="loading">
      <div class="row">
        <div class="col-12 text-center mt-5 pt-5">
          <img src="assets/images/cdmx.gif" width="54" height="54" style="opacity: 0.5;" alt="Icono cargando">
          <p><small>Cargando...</small></p>
        </div>
      </div>
    </div>
  </div>
</div>
